declare const acfOptions: {
    placeholderIcon: string;
    placeholderImage: string;
    placeholderText: string;
} | undefined;

const youtubeIframesInit = (iframe: HTMLElement) => {
    if (typeof acfOptions === 'undefined') {
        return;
    }

    if (!acfOptions.placeholderImage || !acfOptions.placeholderIcon || !acfOptions.placeholderText) {
        return;
    }

    const placeholder = document.createElement("div");
    placeholder.className = "video-wrapper";

    placeholder.innerHTML = `
    <div class="video-overlay">
        <img src="${acfOptions.placeholderImage}" alt="Video placeholder image">
        <div class="overlay-text">
        <div class="icon">${acfOptions.placeholderIcon}</div>
        ${acfOptions.placeholderText}
        </div>
    </div>
    `;

    if (iframe.parentNode) {
        const parentElement = iframe.parentNode as HTMLElement;
        parentElement.style.position = "relative";

        placeholder.appendChild(iframe);
        parentElement.appendChild(placeholder);
    }
};

export default youtubeIframesInit;